var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0157 5C7.56947 5 4 7.9718 4 11.6466C4 13.2124 4.68885 14.6823 5.78474 15.8008C5.409 17.4305 4.09393 18.8684 4.09393 18.8684C4 18.9323 4 19.0601 4.03131 19.156C4.06262 19.2519 4.15656 19.3158 4.25049 19.3158C6.34834 19.3158 7.85127 18.2932 8.66536 17.6541C9.69863 18.0376 10.8258 18.2932 12.0157 18.2932C16.4618 18.2932 20 15.2895 20 11.6466C20 8.00376 16.4305 5 12.0157 5ZM12.2661 14.203H8.7593C8.32094 14.203 8.00783 13.8835 8.00783 13.4361C8.00783 13.0207 8.32094 12.6692 8.7593 12.6692H12.2661C12.6732 12.6692 13.0176 13.0207 13.0176 13.4361C13.0176 13.8835 12.6732 14.203 12.2661 14.203ZM15.272 11.1353H8.7593C8.32094 11.1353 8.00783 10.8158 8.00783 10.3684C8.00783 9.95301 8.32094 9.6015 8.7593 9.6015H15.272C15.6791 9.6015 16.0235 9.95301 16.0235 10.3684C16.0235 10.8158 15.6791 11.1353 15.272 11.1353Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentLines);
export default __webpack_public_path__ + "static/media/comment-lines.b03c2445d04fd66915b1c777e61b34b9.svg";
export { ForwardRef as ReactComponent };